'use strict';

import template from './forgot_password.html';

const EMAIL_ERROR = 'email-not-exists';
const controller = [
  '$stateParams',
  'password',
  'auth',

  function ($stateParams, password, auth) {
    this.resetPassword = function () {
      this.isLoading = true;
      delete this.isWrongEmail;
      delete this.isEmailSent;

      auth.sendPasswordResetLink(this.email)
        .then(function () {
          this.resetPasswordForm.$setUntouched();
          this.resetPasswordForm.$setPristine();
          this.passwordResetEmail = this.email;
          delete this.email;
        }.bind(this))
        .catch(function (response) {
          var status = response.status;
          var error = response && response.data && response.data.error;

          if (status === 400 && error === EMAIL_ERROR) {
            this.isWrongEmail = true;
          }
        }.bind(this))
        .finally(function () {
          delete this.isLoading;
        }.bind(this));
    };
  }
];
const saForgotPassword = [
  function () {
    return {
      template: template,
      replace: true,
      controllerAs: 'ctrl',
      controller: controller
    };
  }
];

export default saForgotPassword;



// WEBPACK FOOTER //
// ./app/src/modules/forgot_password/forgot_password.component.js